import React from 'react';
import { Routes, Route } from 'react-router-dom'; // Make sure you're using Routes and Route
import HomeScreen from './HomeScreen';  // Import HomeScreen
import TestPage from './TestPage'; // Import TestPage

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomeScreen />} /> {/* Home route */}
        <Route path="/test" element={<TestPage />} /> {/* Test page route */}
      </Routes>
    </div>
  );
}

export default App;
